import { Button, SxProps, Theme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import __ from "src/utils/Translations";
import { FC } from "react";

interface IBackButton {
  sx?: SxProps<Theme>;
  onClick?: () => void;
}

const BackButton: FC<IBackButton> = ({ sx, onClick }) => {
  const history = useHistory();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      history.goBack();
    }
  };

  return (
    <Button sx={sx} color="inherit" variant="text" onClick={handleClick}>
      <ArrowBackIcon />
      {__("Wróć")}
    </Button>
  );
};

export default BackButton;
